export default __webpack_public_path__ + "static/media/earface-new.787e69f3.jpg";